import BoxConsommationGraph from '@shared/components/box-consommation-graph';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GraphExporterTel from './telephone-export-wrapper';
import useData from './hook';
import { EmpreinteCarboneTelGraphProps } from './type';

const EmpreinteCarboneTelGraph: React.FC<EmpreinteCarboneTelGraphProps> = ({ data: dataFromProps }) => {
  const { empreinteData, unitToShow, data, unitIndex } = useData(dataFromProps);
  const { t } = useTranslation('domain/home', {
    keyPrefix: 'telephonesAchetes',
  });

  return (
    <BoxConsommationGraph
      consommationData={empreinteData}
      unitToShow={unitToShow}
      title={t('titre')}
      graphTitle={t('graphtitre')}
      info={t('info')}
      exportButton={<GraphExporterTel data={data} unitLabel={unitToShow} unitIndex={unitIndex} />}
    />
  );
};
export default EmpreinteCarboneTelGraph;
